//Navbar.jsx
import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../components/logo.png";
import { useAuth } from "../auth/AuthContext";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [transitioning, setTransitioning] = useState(false);
  const { loading, isAuthenticated, user, logout } = useAuth();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const close = () => {
  setTransitioning(true);
  setOpen(false);
  setTimeout(() => setTransitioning(false), 300); // espera a que acabe la transición
};

  const doLogout = async () => {
    try {
      await logout();
      close();
      navigate("/");
    } catch (e) {
      alert("No se pudo cerrar sesión.");
    }
  };

  return (
    <>
      {/* HEADER — completamente aislado */}
      <header className="nav">
        <div className="nav__inner">
          <button
  className="nav__burger"
  aria-label="Abrir menú"
  onPointerDown={(e) => {
    e.stopPropagation();
    if (!transitioning) setOpen((v) => !v); // ← no actúa durante transición
  }}
          >
            <span /><span /><span />
          </button>

          <Link to="/" className="nav__brand" onPointerDown={close}>
            <img className="nav__logo" src={logo} alt="Logo" />
            <div className="nav__brandText">
              <div className="nav__title">M3 Campus</div>
              <div className="nav__subtitle">Electrónica para niños</div>
            </div>
          </Link>

          <div className="nav__actions">
            {!loading && !isAuthenticated && (
              <NavLink className="nav__btn" to="/sesion">Iniciar sesión</NavLink>
            )}
            {!loading && isAuthenticated && (
              <button className="nav__btn" type="button" onPointerDown={doLogout}>
                Logout{user?.nombre ? ` (${user.nombre})` : ""}
              </button>
            )}
            <NavLink className="nav__cart" to="/carrito" aria-label="Carrito">
              <CartIcon />
            </NavLink>
          </div>
        </div>
      </header>

      {/* DRAWER — completamente separado del header */}
      {open && (
        <div
          className="nav__drawer"
          onPointerDown={(e) => {
            // Solo cierra si el toque fue en el fondo oscuro, no en el panel
            if (e.target === e.currentTarget) close();
          }}
        >
          <div className="nav__drawerPanel">
            <div className="nav__drawerHeader">
              <div className="nav__drawerTitle">Menú</div>
              <button className="nav__close" onPointerDown={close}>✕</button>
            </div>
            <nav className="nav__drawerLinks">
  
  <NavLink to="/menu2" onClick={close} className="nav__link">Contenido didáctico de los Campus</NavLink>
  <NavLink to="/inscripcion" onClick={close} className="nav__link">Inscribir en Campus</NavLink>
  <NavLink to="/Contacto" onClick={close} className="nav__link">Contacto</NavLink>
  <NavLink to="/menu1" onClick={close} className="nav__link">Método M3</NavLink>
  {!loading && isAuthenticated && (
    <NavLink to="/mis-matriculas" onClick={close} className="nav__link">Mis inscripciones</NavLink>
  )}
  {!loading && isAuthenticated && (
    <NavLink to="/historial-matriculas" onClick={close} className="nav__link">Campus realizados</NavLink>
  )}
  {!loading && !isAuthenticated && (
    <NavLink to="/sesion" onClick={close} className="nav__link">Iniciar sesión</NavLink>
  )}
  {!loading && isAuthenticated && (
    <button className="nav__link" type="button" onClick={doLogout}
      style={{ textAlign: "left", background: "white", border: "1px solid rgba(0,0,0,0.08)", padding: "14px 16px", width: "100%" }}>
      Cerrar sesión
    </button>

            
              )}
            </nav>
          </div>
        </div>
      )}
    </>
  );
}

function CartIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M7 7h14l-2 8H8L7 7Zm0 0L6.3 4.6A1 1 0 0 0 5.33 4H3"
        stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.2 20.2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        fill="currentColor" />
    </svg>
  );
}